import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button, Grid } from "@material-ui/core";
import moment from "moment";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from "@material-ui/core/Tooltip";
import DarkButton from "./../../../Global/DarkButton";
import Chart  from "react-apexcharts";
import Color from '../../../Global/colors'
import Typography from "@material-ui/core/Typography";
import {useTranslation} from 'react-i18next';
import { useSelector } from "react-redux";
const useStyles = makeStyles({
  table: {
    minWidth: 200,
  },
   container: {
    maxHeight: window.innerHeight*.30 - 10,
  },
});

function createData(location, auditname, date, score) {
  return { location, auditname, date, score };
}

const rows = [
  createData("London", "Template cleaning and stuff", "November 27,2020", 50),
  createData("South Whales", "Test 6 moaaz", "November 30,2020", 25),
  createData("Yorkshire", "Image image", "November 31,2020", 57),
  createData("Brisbane", "Weekly Inspection", "December 02,2020", 75),
  createData("London", "test 1 sche", "December 02,2020", 95),
];

export const MyDataGrid = ({
  handleAuditClick,
  dataGlobal,
  handleLocationClick,
  handleNameClick,
  handleAuditorClick,
  barChartData,
  dateChart,
  filterByDateChart,
  setTableFilterOption,
  tableData,
  toggletable,
  tableFilterDate,
  tableFilterOption,
  handlePdfDownload,
  setDownloadIndex,
  downloadIndex,
}) => {
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  console.log(tableFilterDate);
  return (
    // <TableContainer component={Paper} style={{margin: 10, height: window.innerHeight*.30, overflow: "auto" }}>
    <Grid container style={{width:'100%'}}>
        <Grid item xs={12}>
          <Paper
            style={{
              overflow: "hidden",
              padding: 0,
              marginTop: "20px",
              backgroundColor:'white', boxShadow:' 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)', borderRadius:'10px',
              //borderRadius: 20,
              height: window.innerHeight*.30, overflow: "auto"
            }}
            variant="outlined"
          >
            <TableContainer className={classes.container}>
      <Table className={classes.table}  stickyHeader aria-label="sticky table" style={{position:"relative"}}>
        <TableHead>
          <TableRow style={{position:'relative'}}>
            <TableCell  style={{textAlign:language == 'ar' ? "right" : "left", paddingTop:'10px' ,padding:'10px',fontWeight: "bold",  color:Color.globalColor8,textTransform:"capitalize" }}>{t("Location")} </TableCell>
            <TableCell  style={{textAlign:language == 'ar' ? "right" : "left", paddingTop:'10px' ,padding:'10px',fontWeight: "bold",  color:Color.globalColor8,textTransform:"capitalize" }}>{t("Template")} </TableCell>
            <TableCell  style={{textAlign:language == 'ar' ? "right" : "left", paddingTop:'10px' ,padding:'10px',fontWeight: "bold",  color:Color.globalColor8,textTransform:"capitalize" }}>{t("Date")} </TableCell>
            <TableCell  style={{textAlign:language == 'ar' ? "right" : "left", paddingTop:'10px' ,padding:'10px',fontWeight: "bold",  color:Color.globalColor8,textTransform:"capitalize" }}>{t("Score")} </TableCell>
            <TableCell  style={{textAlign:language == 'ar' ? "right" : "left", paddingTop:'10px' ,padding:'10px',fontWeight: "bold",  color:Color.globalColor8,textTransform:"capitalize" }}>{t("Download")} </TableCell>
            <Tooltip title={t("Represents the inspection details with location, template format, date, score and download option.")}>
                        <HelpOutlineIcon style={{color:Color.globalColor8, cursor:'pointer', position:'absolute', right:10 , top:10}} />
                    </Tooltip>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData
            ?.filter((v) =>
              tableFilterOption
                ? tableFilterOption === "=" && v.comment === 'In Approval'
                  ? v.isCompleted === true
                  : tableFilterOption === "Approved"
                  ? v.comment === true
                  : tableFilterOption === "Rejected"
                  ? v.comment === false && v.isCompleted === true
                  : tableFilterOption === "<"
                  ? v.isCompleted === false
                  : moment(new Date(v.date)).format("MMMM DD, YYYY") ===
                    tableFilterDate
                : v
            )
            .map((row, i) => {

              console.log("row",row);
              let bgColor = i % 2 === 0 ? "#fff" : "#fbfbfb"
               
              let pillColor =
                row.score < 50
                  ? "red"
                  : row.score >= 50 && row.score < 75
                  ? "#ff9539"
                  : "#06a05d";
              return <TableRow key={i} style={{ backgroundColor: bgColor }}>
                  <TableCell component="th" scope="row" style={{padding:'10px',textAlign:language == 'ar' ? "right" : "left",}}>
                    {row.site}
                  </TableCell>
                  <TableCell align="" style={{padding:'10px',textAlign:language == 'ar' ? "right" : "left",}}>{row.title}</TableCell>
                  <TableCell align="" style={{padding:'10px',textAlign:language == 'ar' ? "right" : "left",}}>
                    {moment(row.date).format("MMMM DD, YYYY")}
                  </TableCell>
                  <TableCell align="center" style={{padding:'10px',textAlign:language == 'ar' ? "right" : "left",}}>
                    <Grid container>
                      {/* <Grid item xs={6}>
                        {parseInt(row.score) ? row.score.toFixed() : 0}%
                      </Grid> */}
                      {/* <Grid item xs={12}> */}
                      {/* <span
                          style={{
                            borderRadius: 30,
                            backgroundColor: pillColor,
                          }}
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span> */}
                      <div className="col radial-chart" style={{ marginLeft: -8, marginTop: -15, paddingTop: 5, maxHeight: 30, width: 40, display: "flex", justifyContent: "center" }}>
                        <Chart options={{ plotOptions: { radialBar: { offsetY: -14, startAngle: -135, endAngle: 225, hollow: { margin: 2, size: "40%", background: "#2a6e9b", image: undefined, imageOffsetX: 0, imageOffsetY: 0, position: "front", dropShadow: { enabled: false, top: 3, left: 0, blur: 4, opacity: 0.24 } }, track: { background: "#fff", strokeWidth: "50%", margin: 4, dropShadow: { enabled: true, top: 0, left: 0, blur: 2, opacity: 0.35 } },  // margin is in pixels
                                dataLabels: { showOn: "always", name: { //offsetY: -20,
                                    show: false, color: "#FFF", fontSize: "10px" }, value: { formatter: function(val) {
                                      return val + "%";
                                    }, offsetY: 3, color: "#FFF", fontSize: "10px", show: true } } } }, fill: { type: "gradient", gradient: { shade: "dark", shadeIntensity: 1, opacityFrom: 0.7, opacityTo: 0.9, colorStops: [{ offset: 0, color: "#01defe", opacity: 1 }, { offset: 20, color: "#1459f3", opacity: 1 }] } }, stroke: { lineCap: "round" } }} series={[parseInt(row.score) ? row.score.toFixed() : 0]} type="radialBar" width="110" />
                      </div>
                      {/* </Grid> */}
                    </Grid>
                  </TableCell>
                  <TableCell align="left" style={{padding:'10px'}}>
                    {/* <DarkButton
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setDownloadIndex(i);
                        handlePdfDownload(row.id);
                      }}
                      disabled={i == downloadIndex || downloadIndex !== null}
                    >
                      {downloadIndex == i ? "Downloading..." : "Download"}
                    </DarkButton> */}

                    <Button variant="contained" type="submit" className="startInspectionBtnSmall" component="span" onClick={() => {
                        setDownloadIndex(i);
                        handlePdfDownload(row.id,row.isCompleted,row.pdf_url);
                      }} disabled={i == downloadIndex || downloadIndex !== null}>
                      {downloadIndex == i ? "Downloading..." : "Download"}
                    </Button>
                  </TableCell>
                </TableRow>;
            })}
        </TableBody>
      </Table>
      </TableContainer>
      </Paper>
      </Grid>
      </Grid>
    // </TableContainer>
  );
};
